@let hasQualificationV2CreatePermission =
  can(RoleAction.Create, RolePermissionSubject.UserQualificationV2);
@let hasQualificationV2UpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.UserQualificationV2);
@let finalizableQualificationTrainings =
  (finalizableQualificationTrainings$ | async) || [];
@let selectedQualificationsTrainings = selectedQualificationsTrainings$ | async;
@let loading = loading$ | async;

<button
  nz-button
  nzType="primary"
  (click)="showTrainingQualificationFinalizeDrawer()"
  [disabled]="
    !hasQualificationV2CreatePermission ||
    !hasQualificationV2UpdatePermission ||
    !finalizableQualificationTrainings?.length ||
    loading
  "
  [nzLoading]="loading"
  nz-tooltip
  [nzTooltipTitle]="
    !hasQualificationV2CreatePermission || !hasQualificationV2UpdatePermission
      ? ('general.no_permissions' | translate)
      : selectedQualificationsTrainings?.length &&
          finalizableQualificationTrainings?.length === 0
        ? ('page.training_qualifications.finalize.trigger.no_trainings_to_finalize'
          | translate)
        : null
  "
  [nzTooltipTrigger]="
    !hasQualificationV2CreatePermission ||
    !hasQualificationV2UpdatePermission ||
    (selectedQualificationsTrainings?.length &&
      finalizableQualificationTrainings?.length === 0)
      ? 'hover'
      : null
  "
>
  {{ 'page.training_qualifications.finalize' | translate }}
  @if (finalizableQualificationTrainings?.length) {
    ({{ finalizableQualificationTrainings?.length }})
  }
</button>
